import type { MapLocationDefinition } from '../domain/types';
import { soldierMissionId, townSquareMissionId } from './mapCatalog';

export const mapLocations: MapLocationDefinition[] = [
  {
    id: 'raadhustorvet',
    title: 'Fire erhverv foran rådhuset',
    shortTitle: 'Rådhustorvet',
    mapPosition: { x: 0.3874, y: 0.5301 },
    sceneId: 'raadhustorvet-scene',
    status: 'available',
    teaser: 'Fire symboler og en tom sæk sætter udflugten i gang.',
  },
  {
    id: 'soldaterboegen',
    title: 'Soldaterbøgen',
    shortTitle: 'Soldaterbøgen',
    mapPosition: { x: 0.66, y: 0.36 },
    sceneId: 'soldaterboegen-scene',
    status: 'available',
    teaser: 'Et mærke i et gammelt træ gemmer på en historie.',
  },
];

export function playableLocationForMission(missionId: string): MapLocationDefinition | undefined {
  const locationIds: Record<string, string> = {
    [soldierMissionId]: 'soldaterboegen',
    [townSquareMissionId]: 'raadhustorvet',
  };
  return mapLocations.find(
    (location) =>
      location.id === locationIds[missionId] && location.status === 'available' && location.sceneId,
  );
}

export function canSelectLocation(
  location: MapLocationDefinition,
  completedPuzzles: readonly string[],
): boolean {
  return (
    location.status === 'available' &&
    Boolean(location.sceneId) &&
    (location.id === 'raadhustorvet' || completedPuzzles.includes('h01-four-trades'))
  );
}

export function selectableLocationForMission(
  missionId: string,
  completedPuzzles: readonly string[],
): MapLocationDefinition | undefined {
  const location = playableLocationForMission(missionId);
  return location && canSelectLocation(location, completedPuzzles) ? location : undefined;
}
